import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportSubscriptionsDetailPageRoutingModule } from './report-subscriptions-detail-routing.module';

import { ReportSubscriptionsDetailPage } from './report-subscriptions-detail.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportSubscriptionsDetailPageRoutingModule
  ],
  declarations: [ReportSubscriptionsDetailPage]
})
export class ReportSubscriptionsDetailPageModule {}
